import { Typography } from '@chargeafter/ui';
import { SxProps, styled } from '@mui/system';
import { formatTimeMinutes, formatTimeSeconds } from '../formattingUtils';
import { Box } from '@mui/material';
import { FC } from 'react';

interface CountdownClockProps {
  countdownInSeconds: number;
  description?: string;
  className?: string;
  descriptionProps?: {
    sx: SxProps;
  };
}

const StyledTypography = styled(Typography)(({ theme }) => ({
  textShadow: 'none',
  letterSpacing: theme.spacing(2),
  lineHeight: '100%',
  fontVariantNumeric: 'tabular-nums',
}));

export const CountdownClock: FC<CountdownClockProps> = ({
  countdownInSeconds,
  description,
  className,
  descriptionProps,
}) => {
  const minutes = formatTimeMinutes(countdownInSeconds);
  const seconds = formatTimeSeconds(countdownInSeconds);
  return (
    <StyledTypography
      variant="main"
      className={className}
      data-testid="clock-typography"
    >
      {`${minutes[0]}${minutes[1]}:${seconds[0]}${seconds[1]}`}
      {description && (
        <Box component="span" {...descriptionProps}>
          {' '}
          {description}
        </Box>
      )}
    </StyledTypography>
  );
};
